<template>
  <div>
    <TeJobPhpCover />

    <TeJobAbout>
      <template #title>
        PHP
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          PHPを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-kimura.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Tomoaki Kimura"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Tomoaki Kimura
          </h4>
          <p>
            プログラミングの楽しさに魅せられて、ついには転職してしまった元営業マン。自らが苦労した経験から、常に「全くの初心者に分かりやすく！！」を追求している。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-sasagawa.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Kiyoshi Sasagawa"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Kiyoshi Sasagawa
          </h4>
          <p>
            20年ほど前から独学でHTMLを始める。CSS・JavaScript/jQueryを得意とし、WordPress・Photoshop・Illustratorなどの技術にも明るい。豊富な経験から、様々な企業のWebサイトにおいて開発業務を行っている。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          PHPメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHtml5"
                class="size-11 text-[#e44d26]"
              />
            </template>
            <template #title>
              HTML/CSS3
            </template>
            <template #description>
              HTML/CSS の業務経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                class=""
                src="~/assets/images/Te/TeJob/Skill/curriculum-php.png"
                alt="php"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              PHP
            </template>
            <template #description>
              PHPを用いた開発経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faDatabase"
                class="h-11 w-9 text-[#024365]"
              />
            </template>
            <template #title>
              MySQLのデータ操作
            </template>
            <template #description>
              ターミナルでMySQLのデータ操作（CRUD）の経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faGear"
                class="h-11 w-9 text-[#563d7c]"
              />
            </template>
            <template #title>
              Webアプリケーションの開発経験
            </template>
            <template #description>
              PHPとMySQLを連携したWebアプリケーションの開発経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faLaptop"
                class="h-11 w-12 text-co-success-500"
              />
            </template>
            <template #title>
              ITの基礎知識
            </template>
            <template #description>
              コンピュータ（ハードウェアの役割）、プログラム（ソートアルゴリズムなど）、インターネット（TCP/IP、HTTPリクエストなど）の基礎的な理解
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="php" />
  </div>
</template>
<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobPhpCover from '~/components/Te/TeJob/Php/TeJobPhpCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHtml5 } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faDatabase, faGear, faLaptop } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

useJobHead()

useHead({
  title: 'PHP講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするPHPメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'PHP講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするPHPメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-php.jpg',
      ogTitle: 'PHP講師（メンター）募集',
      ogDescription:
        '受講生をサポートするPHPメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/php',
      ogImage: '/_nuxt/ogp/og-image-mentor-php.jpg',
    }),
  ],
})
</script>
